/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';
import BaseInputLayout from './BaseInputLayout';
import { useFormContext } from 'framework/form';

const MultiInputWrapperLayout = ({
  label,
  inputSources,
  children,
  gridTemplateColumns,
  isRequired,
}: {
  label?: string;
  inputSources: string[];
  children: React.ReactNode;
  gridTemplateColumns: string;
  isRequired?: boolean;
}) => {
  const { formErrors = {} } = useFormContext();

  const errorMessages = inputSources.flatMap(source => formErrors[source] || []);

  return (
    <BaseInputLayout
      label={label as any}
      source={inputSources[0]}
      errorMessages={errorMessages}
      isRequired={isRequired}
      className="multi-input__wrapper"
      sx={{
        mb: 0,
        '& > .Mui-error': { display: 'none' },
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gap: '12px',
          gridTemplateColumns,
          '& .label__wrapper': { display: 'none' },
        }}
        className="multi-input__inner"
      >
        {children}
      </Box>
    </BaseInputLayout>
  );
};

export default MultiInputWrapperLayout;
